import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'
import {
  InvoiceHistorySliceState,
  InvoicingHistory,
} from '../../../../../types/ProjectManagement/Project/ProjectView/Invoices/invoiceHistoryTypes'
import { AppDispatch, RootState } from '../../../../../stateStore'
import { LoadingState, ValidationError } from '../../../../../types/commonTypes'
import invoiceTimeLineApi from '../../../../../middleware/api/ProjectManagement/Projects/ProjectView/Invoices/invoiceTimeLineApi'
import { ApiLoadingState } from '../../../../../middleware/api/apiList'

const invoiceTimeLine = createAsyncThunk<
  InvoicingHistory[],
  number,
  {
    dispatch: AppDispatch
    state: RootState
    rejectValue: ValidationError
  }
>(
  'invoiceTimeLineView/invoiceTimeLine',
  async (invoiceId: number, thunkApi) => {
    try {
      return await invoiceTimeLineApi.invoiceTimeLine(invoiceId)
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)
export const initialinvoiceState: InvoiceHistorySliceState = {
  isLoading: ApiLoadingState.idle,
  invoicingHistory: [],
}
const invoiceHistorySlice = createSlice({
  name: 'invoiceTimeLine',
  initialState: initialinvoiceState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(invoiceTimeLine.fulfilled, (state, action) => {
        state.isLoading = ApiLoadingState.succeeded
        state.invoicingHistory = action.payload
      })
      .addCase(invoiceTimeLine.pending, (state) => {
        state.isLoading = ApiLoadingState.loading
      })
  },
})
const isLoading = (state: RootState): LoadingState =>
  state.invoiceTimeLine?.isLoading

const invoiceTimeLineHistory = (state: RootState): InvoicingHistory[] =>
  state.invoiceTimeLine?.invoicingHistory

const invoiceHistoryThunk = {
  invoiceTimeLine,
}
const invoiceHistorySelectors = {
  isLoading,
  invoiceTimeLineHistory,
}
export const invoiceTimeLineService = {
  ...invoiceHistoryThunk,
  actions: invoiceHistorySlice.actions,
  selectors: invoiceHistorySelectors,
}

export default invoiceHistorySlice.reducer
